import React from 'react'
import { Button } from 'semantic-ui-react'
import * as Config from '../../../public/external-links'
import Accordion from '../../common/Accordion'

export const WarningLetterFooter = (props) => {
  return (
    <Accordion
      heading="Your template letter is now ready"
      expanded={props.show}
      onClick={() => props.setShow()}
    >
      <p>You can download your letter to your device.</p>
      <p>
        This will create a Word document that you can review and edit before you
        send it to your employee.
      </p>
      <h3>Important information</h3>
      <p>
        You should carefully check the terms in your template Warning letter.
        You may wish to seek professional advice to make sure they are suitable
        for your business.
      </p>
      <h3>Save to your device</h3>
      <Button className="ui is-primary button" onClick={props.handleDownload}>
        Download
      </Button>
      <p>
        After issuing a warning letter you should monitor the employee&apos;s
        performance and continue to provide feedback and encouragement.
      </p>
      <p>
        Discussing performance issues can be challenging and confronting for
        both you and your employee, but it is important. Poor performance
        doesn&apos;t just affect the individual employee – it can also impact
        their co-workers, your customers and your business.
      </p>

      <h3>You might also be interested in:</h3>
      <ul>
        <li>
          <a
            href={Config.INTERACTIVE_TEMPLATE_MANAGING_PERFORMANCE}
            rel="noreferrer"
            target="_blank"
            className="external-link"
          >
            Managing performance online course
          </a>
        </li>
        <li>
          <a
            href={Config.INTERACTIVE_TEMPLATE_MANAGING_EMPLOYEES}
            rel="noreferrer"
            target="_blank"
            className="external-link"
          >
            Managing employees online course
          </a>
        </li>
        <li>
          <a
            href={Config.MANAGING_UNDERPERFORMANCE}
            rel="noreferrer"
            target="_blank"
            className="external-link"
          >
            Best Practice Guide – Managing underperformance
          </a>
        </li>
        <li>
          <a
            href={Config.INTERACTIVE_TEMPLATE_PERFORMANCE_SYSTEM_CHECKLIST}
            rel="noreferrer"
            target="_blank"
            className="external-link"
          >
            Setting up a performance system checklist (DOCX 32.7KB)
          </a>
        </li>
        <li>
          <a
            href={
              Config.INTERACTIVE_TEMPLATE_PERFORMANCE_REVIEW_DISCUSSION_PLAN
            }
            rel="noreferrer"
            target="_blank"
            className="external-link"
          >
            Performance review discussion plan (DOCX 35.4KB)
          </a>
        </li>
      </ul>
    </Accordion>
  )
}
